defineCustomVueElement('csb-brand-group-list', {
  name: 'Brand Group List',
  template: `<div class="brand-list">
  <div class="page-width">
    <h2></h2>
    <div class="group" v-for="item in csbStore.groups">
      <a :href="item.collection.uri" v-if="item.collection != null && item.collection.image != null"><img :src="item.collection.image" style="width: 150px; height: 150px;" /></a>
      <h3><a :href="item.collection.uri" v-html="item.name" v-if="item.collection != null"></a></h3>
      <ul>
        <li v-for="model in item.models" v-html="model"></li>
      </ul>
    </div>
  </div>
</div>`,
  data() {
    return {
      csbStore: useCsbStore()
    }
  },
  async mounted() {
    await this.csbStore.init()
  }
}, { plugins: [ piniaStore ] })